export const formatDateTypeEnum = {
  dateTime: "dateTime",
  date: "date",
  time: "time",
};
